const e = {
  getPlayerDepositEnrollment: {
    schema: {
      method: "get",
      url: "/players/{trigger}/{uid}"
    }
  }
};
export {
  e as playersService
};
